import apiService from '../../../../share/util/api/service';
import { executeSyncRequest } from '../../../../share/util/api/syncRequest';
import diagnoseResource from "../../../../share/util/diagnose";
import { PHASE } from './constants';
import { terminate } from './terminate';
import { dispose } from './dispose';

/**
 * プロジェクトデータ保存
 * @param {object} self this インスタンス
 */
export async function save(self) {
  try {
    self.isLoading = true;

    const endPoint = '/projects/' + self.vehicleInfo.vehicle.project.id
      + '/netApps/' + self.netAppId
      + '/requests/' + self.requestId;

    const postReqBody = {
      storage_data: self.resultItems,
      data_name: self.dataName
    };

    await executeSyncRequest(
      self,
      // POST API 呼び出しのコールバック
      async () => await apiService.postCall(
        apiService.WSP,
        endPoint,
        postReqBody,
        diagnoseResource.operationFrom(self.$router.currentRoute.value.name)
      ),
      // エラー発生のコールバック
      async (errorType) => { errorType; await self.showUnexpectedError(); },
      // POST API レスポンスチェックのコールバック
      // レスポンスは見ない
      (postApiResponse) => { postApiResponse; return ''; },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
      async (result) => { await self.validateErrorResult(result); }
    );

    await (self.isSession ? terminate : dispose)(self, PHASE.DATA_RESULTS_DISPLAY);
  } finally {
    self.isLoading = false;
  }
}